import {take, fork, put, select} from 'redux-saga/effects';
import {push, resolveRoute, prepareSearchQueryParams} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import routePaths from '../../routePaths';
import fetchRequest from '../../application/sagas/fetchRequest';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as serviceAssignmentActionTypes from '../../service-assignments/serviceAssignmentActionTypes';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import * as savaActionTypes from '../savaActionTypes';
import savaScreenTabs from '../savaScreenTabs';

const createServiceAssignmentVehicleAdditionalFlow = function* createServiceAssignmentVehicleAdditionalFlow() {
    const {serviceManager} = yield select(state => state.application);
    const ecsFlowService = serviceManager.loadService('ecsFlowService');

    while (true) {
        const {payload} = yield take(savaActionTypes.CREATE_SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL);
        const {serviceCaseId, serviceType} = payload;
        const {serviceCases = {}} = yield select(state => state.serviceCases);
        const serviceCase = serviceCases[serviceCaseId] || null;

        yield fork(
            fetchRequest,
            savaActionTypes.CREATE_SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL_REQUEST,
            ecsFlowService.createServiceAssignment,
            {
                serviceCaseId,
                assignmentType: efServiceAssignmentTypes.VEHICLE,
                serviceType, // NOTE: BE to add serviceType parameter to POST /service-assignments
            },
        );

        const responseAction = yield take([
            savaActionTypes.CREATE_SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL_REQUEST_SUCCEEDED,
            savaActionTypes.CREATE_SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL_REQUEST_FAILED,
        ]);

        // NOTE: errors are handled implicitly as part of the fetchRequest
        // below you can handle something in addition if needed

        if (!responseAction.error) {
            const {response} = responseAction.payload;
            const {serviceAssignmentDTO} = response;
            const serviceAssignmentLineNo = serviceAssignmentDTO.lineNo;

            yield put({
                type: serviceAssignmentActionTypes.STORE_SERVICE_ASSIGNMENTS,
                payload: {serviceAssignmentDTOs: [serviceAssignmentDTO]},
            });

            yield put({
                type: serviceCaseActionTypes.SET_SERVICE_CASE_ASSIGNMENTS,
                payload: {serviceAssignmentDTOs: [serviceAssignmentDTO], serviceCaseId},
            });

            // serviceAssignment.callbackPhoneNo = serviceCase.callbackPhoneNo, by default
            if (serviceCase?.callbackPhoneNo) {
                yield* updateServiceAssignment({
                    caller: savaActionTypes.CREATE_SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL,
                    assignmentType: efServiceAssignmentTypes.VEHICLE,
                    serviceAssignmentLineNo,
                    serviceCaseId,
                    serviceAssignmentData: {
                        callbackPhoneNo: serviceCase.callbackPhoneNo,
                    },
                });
            }

            yield put(push(resolveRoute(
                routePaths.SERVICE_ASSIGNMENT_VEHICLE_ADDITIONAL,
                {
                    serviceCaseId,
                    serviceAssignmentLineNo,
                },
                {search: prepareSearchQueryParams({activeTab: savaScreenTabs.SERVICE_LOCATION})},
            )));
        }
    }
};
export default createServiceAssignmentVehicleAdditionalFlow;
